<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerFlagsStore = usePlayerFlagsStore()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_first_contact_end', router)
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.firstContact.end.excellentWork') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.firstContact.end.successfullyMade') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.firstContact.end.remember') }}
      </p>
    </template>

    <template #alerts>

    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.firstContact.end.thankYou') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>